import React, { useContext } from "react";

import AnswersContext from "../contexts/AnswersContext";

import ProgressBars from "./ProgressBars";
import Question from "./Question";

const QuestionsTab = ({
  questions,
  index,
  onNext,
  onPrevious,
  onFinish,
  shuffleAnswers,
  showNumbers,
  showAnswers,
  finished,
}) => {
  const { answers } = useContext(AnswersContext);
  return (
    <>
      <ProgressBars
        answers={answers}
        questions={questions}
        showAnswers={showAnswers}
      />
      <main>
        {questions.length > 0 ? (
          <Question
            questionID={questions[index]}
            shuffleAnswers={shuffleAnswers}
            showNumbers={showNumbers}
            showAnswers={showAnswers}
            onNext={onNext}
            onPrevious={onPrevious}
            onFinish={onFinish}
            finished={finished}
          />
        ) : (
          <div className="alert alert-danger" role="alert">
            No questions match the selected options.
          </div>
        )}
      </main>
    </>
  );
};

export default QuestionsTab;
